export default __webpack_public_path__ + "static/media/p2023-39.c4eaf1cc.jpeg";